import { useEffect, useState } from 'react';
import { PrimaryBtn } from '../Assets/Buttons';
import { Field, Label } from '../Assets/Fieldset';
import { Input } from '../Assets/Input';
import { Text } from '../Assets/Text';

const ConfirmPassForm = (props) => {
    const [isValid, setIsValid] = useState(false);
    const [codeValid, setCodeValid] = useState(false);
    const [newPassValid, setNewPassValid] = useState(false);
    const [confPassValid, setConfPassValid] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        props.handleSubmit();
    };

    const validateCode = (e) => {
        let tmpCode = e.target.value;
        props.setCode(tmpCode);
        setCodeValid(tmpCode !== "" && tmpCode !== null && tmpCode !== undefined);
    };

    const validateNewPass = (e) => {
        let tmpPass = e.target.value;
        props.setNewPass(tmpPass);
        const passRegex = /(?=.*\d)(?=.*[!@#$%^&?*])(?=.*[a-z])(?=.*[A-Z]).{8,}/;
        setNewPassValid(passRegex.test(tmpPass));
    };

    const validateConfPass = (e) => {
        let tmpPass = e.target.value;
        props.setConfPass(tmpPass);
        setConfPassValid(tmpPass === props.newPass);
    };

    useEffect(() => {
        if(codeValid && newPassValid && confPassValid) {
            setIsValid(true);
        } else {
            setIsValid(false);
        }
    }, [codeValid, newPassValid, confPassValid]);

    return (
        <form onSubmit={handleSubmit} className="grid w-full max-w-sm grid-cols-1 gap-6">
            <Field>
                <Label>Reset Code</Label>
                <Input
                    type="text"
                    value={props.code}
                    onChange={validateCode}
                    required
                    aria-invalid={!codeValid && props.code !== '' ? "true" : "false"}
                    placeholder="Enter the code from your email"
                />
            </Field>

            <Field>
                <Label>New Password</Label>
                <Input
                    type="password"
                    value={props.newPass}
                    onChange={validateNewPass}
                    required
                    autoComplete="new-password"
                    aria-invalid={!newPassValid && props.newPass !== '' ? "true" : "false"}
                    placeholder="Create a strong password"
                />
                {props.newPass && !newPassValid && (
                    <Text className="text-brand-red-500 text-sm mt-1">
                        Password must contain at least 8 characters, including uppercase and lowercase letters, numbers, and special characters.
                    </Text>
                )}
            </Field>

            <Field>
                <Label>Confirm Password</Label>
                <Input
                    type="password"
                    value={props.confPass}
                    onChange={validateConfPass}
                    required
                    autoComplete="new-password"
                    aria-invalid={!confPassValid && props.confPass !== '' ? "true" : "false"}
                    placeholder="Confirm your password"
                />
                {props.confPass && !confPassValid && (
                    <Text className="text-brand-red-500 text-sm mt-1">
                        Passwords do not match.
                    </Text>
                )}
            </Field>

            {props.err && (
                <Text className="text-brand-red-500">{props.err}</Text>
            )}

            <PrimaryBtn
                type="submit"
                disabled={!isValid}
                className="w-full"
            >
                Reset Password
            </PrimaryBtn>
        </form>
    );
};

export default ConfirmPassForm;